module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<h1 class=\"heading1\">\n    Loading\n    <loading-indicator></loading-indicator>\n</h1>\n";
